import { render } from "./roles_select.vue?vue&type=template&id=4b1f1ca9"
import script from "./roles_select.vue?vue&type=script&lang=js"
export * from "./roles_select.vue?vue&type=script&lang=js"
script.render = render

export default script